module.exports = __webpack_public_path__ + "static/media/20ECE11.a9bd2775.jpg";